<template>
    <div class="pa-0 ma-0">
        <div class="margen d-flex">
            <hr class="vr"/>
            <p v-if="rol == 'empleado'" class="tblName">¡Hola, que tengas un excelente día!</p>
            <p v-else class="tblName">Bienvenido</p>
        </div>
        <v-overlay :value="overlayDescarga" >
            <div class="align-center justify-center text-center">
                <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="#2DB9D1"
                >
                    <v-img
                        src="/static/icon/favicon.ico"
                        :width="60"
                    ></v-img>
                </v-progress-circular>
                <p>{{fraseOverlay}}</p>
            </div>
        </v-overlay>
        <v-row class="pa-0 ma-0">
            <v-col v-if="showLogros" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-3">
                <v-card height=43.5em class="elevation-0" style="border-radius: 15px;">
                    <v-card-title class="card_titulo padding_derecho padding_izquierdo pb-5">
                        <div class="headerModal-filter">
                            <h2 class="leyenda">Mis logros</h2>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md id="contenedor">
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-list-item :class="disabledLogro('Puntualidad')">
                                    <v-list-item-avatar
                                        tile
                                        size="80"
                                    >
                                        <v-img src="/static/icon/dashboard/misLogros-PuntualidadAsistencia.svg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="textMisLogros mb-1 pl-4">
                                            Puntualidad y asistencia
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="pb-2"></v-divider>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-list-item class="pb-2" :class="disabledLogro('Clima laboral')">
                                    <v-list-item-avatar
                                        tile
                                        size="80"
                                    >
                                        <v-img src="/static/icon/dashboard/misLogros-ClimaLaboral.svg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="textMisLogros mb-1 pl-4">
                                            Clima laboral
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="pb-2"></v-divider>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-list-item class="pb-2" :class="disabledLogro('Antigüedad')">
                                    <v-list-item-avatar
                                        tile
                                        size="80"
                                    >
                                        <v-img src="/static/icon/dashboard/misLogros-Antiguedad.svg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="textMisLogros mb-1 pl-4">
                                            Antigüedad
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="pb-2"></v-divider>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-list-item class="pb-2" :class="disabledLogro('Proyectos')">
                                    <v-list-item-avatar
                                        tile
                                        size="80"
                                    >
                                        <v-img src="/static/icon/dashboard/misLogros-ProyectosMejoras.svg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="textMisLogros mb-1 pl-4">
                                            Proyectos y mejoras
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="pb-2"></v-divider>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-list-item class="pb-2" :class="disabledLogro('Capacitación')">
                                    <v-list-item-avatar
                                        tile
                                        size="80"
                                    >
                                        <v-img src="/static/icon/dashboard/misLogros-Capacitacion.svg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="textMisLogros mb-1 pl-4">
                                            Capacitación
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="!showLogros" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-3">
                <v-card height=43.5em class="elevation-0" style="border-radius: 15px;" >
                    <div class="d-flex flex-column align-center justify-center" style="height: 100%;">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p>{{"Logros..."}}</p>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-3 px-0">
                <v-col v-if="showRecibos" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0 pb-6">
                    <v-card :height="cardAltura" class="elevation-0" style="border-radius: 15px;">
                        <v-card-title class="card_titulo padding_derecho padding_izquierdo pb-5">
                            <div class="headerModal-filter d-flex">
                                <h2 class="leyenda">Últimos recibos</h2>
                                <!-- <v-tooltip top class="pb-7">
                                    <template v-slot:activator="{ on }">
                                        <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                    </template>
                                    <span class="pb-7 textTooltip">
                                        Para más información sobre tus recibos, visita la sección <br>
                                        de <span class="linkTooltip">Mis recibos de nómina</span> en el Detalle de empleado o <br>
                                        bien, dirigirte a la sección desde el menú principal.
                                    </span>
                                </v-tooltip> -->
                                <v-tooltip v-model="showTooltip" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon color='#96999A' @click="showTooltip = !showTooltip" class="mb-7 ml-2 outlined_v_icon">info</v-icon>
                                    </template>
                                    <template v-slot:default>
                                        <span class="pb-7 textTooltip" style="pointer-events: initial;">
                                            Para más información sobre tus recibos, visita la sección <br>
                                            de <span class="linkTooltip" @click="irDetalle()">Mis recibos de nómina</span> en el Detalle de empleado o <br>
                                            bien, dirigirte a la sección desde el menú principal.
                                        </span>
                                    </template>
                                </v-tooltip>
                            </div>
                        </v-card-title>
                        <perfect-scrollbar style="background: #fff; overflow:auto;">
                            <v-card-text class="card_texto" >
                                <div
                                    slot="widget-content"
                                    id="misIncidencias"
                                    style="height:140px; width:100%; margin-bottom: 20px;"
                                >
                                    <div class="row col-lg-12 emptyItems align-center justify-center text-center" v-if="itemsTimbres.length == 0">
                                        <p class="col-12py-0 px-0">No hay elementos para mostrar</p>
                                    </div>    
                                    
                                    <template v-else>
                                        <template v-for="(detalle, index) in itemsTimbres">
                                            <v-row :key="index">
                                                <v-col class="d-flex align-center" cols="12" xs="6" sm="6" md="6" lg="8" xl="8">
                                                    <span class="textCard">
                                                        {{ detalle.nomina.periodo.numero }} - {{detalle.nomina.periodo.descripcion_fecha}}
                                                    </span>
                                                </v-col>
                                                <v-col cols="12" xs="6" sm="6" md="6" lg="4" xl="4">
                                                        <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                v-on="on"
                                                                fab
                                                                small
                                                                color="#FFFFFF"
                                                                @click="descargarTimbre(detalle,false,'pdf')"
                                                                elevation="0"
                                                            >
                                                                <v-icon color="#96999A" class="colorMdiFilePdf">mdi-file-pdf-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>PDF</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                v-on="on"
                                                                fab
                                                                small
                                                                color="#FFFFFF"
                                                                @click="descargarTimbre(detalle,false,'xml')"
                                                                elevation="0"
                                                            >
                                                                <v-icon color="#96999A" class="colorMdiFileXml">mdi-file-xml</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>XML</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                v-on="on"
                                                                fab
                                                                small
                                                                color="#FFFFFF"
                                                                @click="descargarTimbre(detalle,false,'zip')"
                                                                elevation="0"
                                                            >
                                                                <v-icon color="#96999A" class="colorMdiZip">mdi-zip-box</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>ZIP</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </template>
                                </div>
                            </v-card-text>
                        </perfect-scrollbar>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0" >
                    <v-card :height="cardAltura" class="elevation-0" style="border-radius: 15px;">
                        <v-card-title class="card_titulo padding_derecho padding_izquierdo pb-5">
                            <div class="headerModal-filter d-flex">
                                <h2 class="leyenda">Mis incidencias</h2>
                                <!-- <v-tooltip top class="pb-0" v-model="showTooltip">
                                    <template v-slot:activator="{ on }">
                                        <v-icon color='#96999A' v-on="on" @click="showTooltip = !showTooltip" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                    </template>
                                    <span class="pb-0 textTooltip">
                                        Para más información sobre tus recibos, visita la sección <br>
                                        de <span class="linkTooltip">Mis recibos de nómina</span> en el Detalle de empleado o <br>
                                        bien, dirigirte a la sección desde el menú principal.
                                    </span>
                                </v-tooltip> -->
                                <v-tooltip v-model="showTooltip2" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon color='#96999A' @click="showTooltip2 = !showTooltip2" class="mb-7 ml-2 outlined_v_icon">info</v-icon>
                                    </template>
                                    <template v-slot:default>
                                        <span class="pb-0 textTooltip" style="pointer-events: initial;">
                                            Si deseas saber más sobre tus incidencicas, puedes <br>
                                            hacer clic sobre este link <span class="linkTooltip" @click="irIrncidencias()">Incidencias</span> o bien,<br>
                                            dirigirte a la sección desde el menú principal.   
                                        </span>  
                                    </template>
                                </v-tooltip>
                            </div>
                        </v-card-title>
                        <perfect-scrollbar style="background: #fff; overflow:auto;">
                            <v-card-text class="card_texto" >
                                <div
                                    slot="widget-content"
                                    id="misIncidencias"
                                    style="width:100%; margin-bottom: 20px;"
                                    :style="showRecibos?'height:140px':'height:90%'"
                                >
                                    <div class="row col-lg-12 emptyItems align-center justify-center text-center" v-if="itemsIncidencias.length == 0">
                                        <p class="col-12py-0 px-0">No hay elementos para mostrar</p>
                                    </div>
                                    <template v-else>
                                        <template v-for="(item, index) in itemsIncidencias">
                                            <v-row :key="index">
                                                <v-col class="d-flex align-center" cols="12" xs="6" sm="6" md="6" lg="8" xl="8">
                                                    <span class="textCard">
                                                        {{ item.nombre_tipo }}
                                                    </span>
                                                </v-col>
                                                <v-col cols="12" xs="6" sm="6" md="6" lg="4" xl="4">
                                                    <v-chip
                                                        class="mx-0 px-0 tipoLetra"
                                                        color="transparent"
                                                        outlined
                                                        :text-color="getColorTextoStatus(item.valor_estatus)"
                                                    >
                                                        <img
                                                            v-if="item.valor_estatus === 'estatus_aprobado'"
                                                            style="height: 20px; width: 20px;  background-color: transparent;"
                                                            src="/static/icon/aprovado.png"
                                                            alt="Empleado"
                                                        />
                                                        <img
                                                            v-else-if="item.valor_estatus === 'estatus_rechazado'"
                                                            style="height: 20px; width: 20px;  background-color: transparent;"
                                                            src="/static/icon/cancelado.png"
                                                            alt="Empleado"
                                                        />
                                                        <img
                                                            v-else-if="item.valor_estatus === 'estatus_pendiente'"
                                                            style="height: 20px; width: 20px;  background-color: transparent;"
                                                            src="/static/icon/pendiente.png"
                                                            alt="Empleado"
                                                        />
                                                        <img
                                                            v-else
                                                            style="height: 20px; width: 20px;  background-color: transparent;"
                                                            src="/static/icon/revision.png"
                                                            alt="Empleado"
                                                        />
                                                        <span class="pl-2 textChip">
                                                            {{item.nombre_estatus }}
                                                        </span>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </template>
                                    
                                </div>
                            </v-card-text>
                        </perfect-scrollbar>
                    </v-card>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import Notify from '@/plugins/notify';
import apiTimbres from '@/api/timbres';
import apiIncidencias from '@/api/incidencias';

export default {
    data() {
        return {
            datosLogin          : null,
            rol                 : null,
            showTooltip         : false,
            showTooltip2        : false,
            overlayDescarga     : false,
            fraseOverlay        : '',
            itemsIncidencias    : [],
            itemsTimbres        : [],
            showRecibos         : false,
            showLogros          : false,
        }
    },
    computed:{
        cardAltura(){
            if(this.$session.get('sistema') == 'nominas'){
                return '21em'
            }
            else{
                return '43.5em'
            }
        }
    },
    methods:{
        disabledLogro(itemLogro){
            let datosEmpleado = []
            datosEmpleado = this.$session.get('empleado');
            let logro = datosEmpleado.objRankig.find(item => item == itemLogro)
            switch (logro) {
                case "Antigüedad":
                    return '';
                    break;
                case "Clima laboral":
                    return '';
                    break;
                case "Proyectos":
                    return '';
                    break;
                case "Puntualidad":
                    return '';
                    break;
                case "Capacitación":
                    return '';
                    break;
                case undefined:
                    return 'disabledLogro';
                    break;
                default:
                    return 'disabledLogro';
                    break;
            }
        },
        irDetalle(){
            this.$session.remove("detalleEmpleado");
            this.$router.push("/empleado/detalleEmpleado");
        },
        irIrncidencias(){
            this.$router.push('/incidencias');
        },
        descargarTimbre(item = null,documento = false, tipo){
            this.overlayDescarga = true;
            this.fraseOverlay = "Descargando";
            let self = this;
            
            const FileDownload = require('js-file-download');
            const axios = require('axios');
            let url = 'nominas-timbres/descargar';
            let fecha = item.timbrado.split(' ');
            let nombre_archivo = "Recibo_de_nomina_"+fecha[0]+"."+tipo; 
            let parametros = {nomina_id:[item.id],tipo}
            try {
                axios({
                    method: 'post',
                    url: url,
                    responseType: 'blob',
                    data: parametros,
                })
                .then(function (response) {
                    FileDownload(response.data,nombre_archivo);
                    self.overlayDescarga = false;
                    self.fraseOverlay = "Cargando";
                
                })
                .catch(async (error)=>{
                    //console.log(err);
                    self.overlayDescarga = false;
                    let errorString = error.response.data;
                    if (
                        error.request.responseType === 'blob' &&
                        error.response.data instanceof Blob &&
                        error.response.data.type &&
                        error.response.data.type.toLowerCase().indexOf('json') != -1
                    ){
                        errorString = JSON.parse(await error.response.data.text());
                        console.log(errorString)

                        if(typeof errorString.error === 'string'){
                            Notify.ErrorToast(errorString.error);
                        }else{
                            let error = Object.values(errorString.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    }; 
                });
            } catch (error) {
                self.overlayDescarga = false
                console.log(error);
                self.fraseOverlay = "Cargando";
            }
        },
        getColorTextoStatus(statusIncidencia) {
            if (statusIncidencia == "estatus_aprobado") return "#15D511";
            if (statusIncidencia == "estatus_rechazado") return "#EE1616";
            if (statusIncidencia == "estatus_pendiente") return "#FF9B05";
            if (statusIncidencia == "estatus_revision") return "#F8690E";
        },
        getTimbres(){
            let parametros = { 
                activo:true, 
                paginate: false, 
                empleado_id: this.datosLogin.empleado_id,
                order:'desc' 
            }
            apiTimbres.getTimbres(parametros).then((response)=>{
                this.itemsTimbres = response.data;
            })
            .catch(error => {
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },
        getIncidencias(){
            let param = {
                rol_name        : this.rol,
                usuario_id      : this.datosLogin.id,
                activo          : true,
                paginate        : true,
                include_padres  : true,
                order_by        : 'fecha_final',
                empleado_id     : this.datosLogin.empleado_id,
            };

            apiIncidencias.getIncidencias(param).then((response) => {
                this.itemsIncidencias = response.data;
            })
            .catch((error) => {
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
            });
        },
    },
    async created(){
        this.datosLogin = this.$session.get('usuario');
        this.rol = this.datosLogin.rol.name;
        if(this.$session.get('sistema') == 'nominas'){
            this.showRecibos = true;
            await this.getTimbres();
        }
        else{
            this.showRecibos = false
        }

        this.getIncidencias();
    },
    mounted(){
        setTimeout(() => {
            this.showLogros = true;
        }, 2000);
    }
}
</script>
<style scoped>
    .margen {
		height: 48px;
		margin-bottom: 20px;
		margin-left: 1px;
	}
    .leyenda {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 29px;
        color: rgba(16, 28, 90);
    }
    .textMisLogros {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 22.3815px;
        line-height: 27px;
        color: #444975;
    }

    .disabledLogro {
        pointer-events: none;
        opacity: 0.4;
    }
    .linkTooltip{
        color:#8AE0EF;
        text-decoration: underline #8AE0EF;
        cursor:pointer;
    }
    .emptyItems{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #c5c5c5;
    }
    .textCard{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
    }
    .textChip{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
    }
    .colorMdiFilePdf:hover{
        color: red !important;
    }
    .colorMdiFileXml:hover{
        color:green !important;
    }
    .colorMdiZip:hover{
        color:blue !important;
    }
    
</style>


